"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwRadioButton = _interopRequireDefault(require("../cwradiobutton/CwRadioButton"));

var _CwRadioButtonGroup = _interopRequireDefault(require("./CwRadioButtonGroup.scss"));

var _CwPodCol = _interopRequireDefault(require("../cwpod/CwPodCol"));

var _CwPodRow = _interopRequireDefault(require("../cwpod/CwPodRow"));

var CwRadioButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwRadioButtonGroup, _React$Component);

  function CwRadioButtonGroup() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CwRadioButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CwRadioButtonGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFocus", function () {
      if (_this.props.disabled || !_this.props.onFocus) {
        return;
      }

      _this.props.onFocus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBlur", function () {
      if (_this.props.disabled || !_this.props.onBlur) {
        return;
      }

      _this.props.onBlur();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (item) {
      if (_this.props.disabled || !_this.props.onChange) {
        return;
      }

      _this.props.onChange(item);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "createRadioButton", function (item) {
      if (!_this.props.value || _this.props.value.id === undefined || !item || item.id === undefined) {
        return;
      }

      var value = {
        id: item.id,
        name: item.name,
        checked: item.id === _this.props.value.id
      };

      var radioButton = _react.default.createElement(_CwRadioButton.default, {
        cwId: "".concat(_this.props.cwId, "_").concat(item.name),
        value: value,
        groupName: _this.props.groupName,
        key: item.id,
        onChange: _this.handleChange,
        invalid: _this.props.invalid,
        disabled: _this.props.disabled,
        onFocus: _this.handleFocus,
        onBlur: _this.handleBlur
      });

      return _react.default.createElement(_CwPodCol.default, {
        className: _CwRadioButtonGroup.default.radioButton,
        key: item.id
      }, radioButton);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRadioButtons", function () {
      if (!_this.props.radioButtons || !_this.props.radioButtons.length > 0) {
        return null;
      }

      var columns = _this.props.columns ? _this.props.columns : _this.props.radioButtons.length;
      var rows = [];
      var j = 0;
      var cells = [];

      for (var i = 0; i < _this.props.radioButtons.length; i++) {
        var item = _this.props.radioButtons[i];
        cells.push(_this.createRadioButton(item));
        j++;

        if (j > columns - 1 || i === _this.props.radioButtons.length - 1) {
          j = 0;
          rows.push(_react.default.createElement(_CwPodRow.default, {
            className: _CwRadioButtonGroup.default.alignRadioButtonsCenter,
            key: "item{".concat(i)
          }, cells));
          cells = [];
        }
      }

      return _react.default.createElement("div", null, rows);
    });
    return _this;
  }

  (0, _createClass2.default)(CwRadioButtonGroup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // Default to first radio button if value is undefined
      if (!this.props.value) {
        // Fire onSystemChange to let consumer know it is not a user interaction change
        this.props.onSystemChange(this.props.radioButtons[0]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Default to first radio button if value is undefined
      if (!nextProps.value) {
        // Fire onSystemChange to let consumer know it is not a user interaction change
        this.props.onSystemChange(nextProps.radioButtons[0]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.getRadioButtons();
    }
  }]);
  return CwRadioButtonGroup;
}(_react.default.Component);

CwRadioButtonGroup.propTypes = {
  /**
  * Connectwise element id to be used as unique identifier
  */
  cwId: _propTypes.default.string,

  /**
   * Array of radio buttons for the group with {id, name} as its shape
   */
  radioButtons: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]).isRequired,
    name: _propTypes.default.string.isRequired
  })).isRequired,

  /**
   * Id of radio button that should be checked, if it does not match
   * an id of a radio button on  the props.radioButtons, none will
   * be checked
   */
  value: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]),
    name: _propTypes.default.string
  }),

  /**
   * Used to control if all radio buttons are invalid, red
   */
  invalid: _propTypes.default.bool,

  /**
   * Used to group radio buttons, radio buttons with the same
   * group name will have mutual exclusivity, only one radio
   * button in a group can be checked
   */
  groupName: _propTypes.default.string,

  /**
   * Used to lay out the radio buttons, it will display the radio buttons
   * across this many columns
   */
  columns: _propTypes.default.number,

  /**
   * Used to disable all radio buttons in this group
   */
  disabled: _propTypes.default.bool,

  /**
   * Callback function fired when a radio button in this group is clicked (by user)
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function fired when a radio button is automatically selected (not by user)
   */
  onSystemChange: _propTypes.default.func,

  /**
   * Callback function fired when a radio button is focued
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function fired when a radio button 
   */
  onBlur: _propTypes.default.func
};
var _default = CwRadioButtonGroup;
exports.default = _default;